module.exports = __webpack_public_path__ + "static/img/avatar.3e47341.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.svg
// module id = Itm0
// module chunks = 1